export const CATEGORIES = [
  {
    type: 'buying',
    color: '#3B7C0F',
    icon: 'coins-stacked-03',
    title: 'Buying signals',
    content: 'Signals that suggest budget, active initiatives, growth, or purchasing intent.'
  },
  {
    type: 'risk',
    color: '#E62E05',
    icon: 'triangle-alert',
    title: 'Risk signals',
    content: 'Alerts that may slow, block, or reduce deal potential, like cuts, layoffs, or legal issues.'
  },
  {
    type: 'people',
    color: '#026AA2',
    icon: 'users',
    title: 'People signals',
    content: 'Stakeholder activity such as hires, departures, promotions, and public engagement.'
  },
  {
    type: 'market',
    color: '#6927DA',
    icon: 'globe-04',
    title: 'Market signals',
    content: 'Competitive moves, launches, and strategic shifts that change the selling landscape.'
  },
]